import styled from 'styled-components';

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  opacity: 0;
  transition: opacity 0.25s ease-in-out;
  ${({ isVisible }) => isVisible && `opacity: 1;`}
`;

export const ModalContent = styled.div`
  background: #ffffff;
  padding: 30px;
  border-radius: 20px;
  max-width: 480px;
  width: 90%;
  text-align: center;
  transform: translateY(-30px);
  transition: transform 0.25s ease-in-out;
  box-shadow: 0 20px 45px rgba(0, 0, 0, 0.15);
  ${({ isVisible }) => isVisible && `transform: translateY(0);`}
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 12px;
  right: 18px;
  background: transparent;
  border: none;
  font-size: 1.7rem;
  cursor: pointer;
  color: #999;
  transition: 0.2s;
  &:hover {
    color: #333;
  }
`;

export const Title = styled.h2`
  font-family: 'Raleway', sans-serif;
  font-weight: 600;
  margin-bottom: 10px;
  font-size: 22px;
`;

export const AfterTitle = styled.p`
  font-family: 'Raleway', sans-serif;
  font-weight: 500;
  font-size: 14px;
  margin-top: 20px;
  margin-bottom: 30px;
`;

export const Description = styled.p`
  font-size: 15px;
  font-family: 'Raleway';
  color: #5a5a5a;
  margin-bottom: 25px;
`;

export const JoinButton = styled.button`
  background: #7d75f8;
  color: white;
  padding: 12px 26px;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  font-family: 'Raleway', sans-serif;
  font-weight: 600;
  font-size: 16px;
  transition: background 0.25s ease;
  &:hover {
    background: #675ff0;
  }
`;

export const OptionButton = styled.button`
  margin: 8px 0;
  padding: 12px 20px;
  width: 100%;
  font-size: 15px;
  font-family: 'Raleway';
  background-color: #f5f5f5;
  border: 1px solid #ddd;
  cursor: pointer;
  border-radius: 10px;
  transition: all 0.2s ease-in-out;
  &:hover {
    background-color: #ebebeb;
  }
`;
